export enum SpatialSeparation {
	Left = 'LEFT',
	Right = 'RIGHT'
}
